import React from 'react'
import styles from './styles/info-box-container.module.scss'

interface Props {
	className?: string
}

/**
 * 
 * Creates styled container for InfoBoxes
 * 
 */

const InfoBoxContainer:React.FC<Props> = ({ children , className }) => {
	return (<div className={`${styles.infoBoxContainer} ${className}`}>{children}</div>)
}


export default InfoBoxContainer;